import { CustomStyles } from '@types';

const styles: Record<string, CustomStyles> = {
  rowEllipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  searchContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: '0.5rem',
    padding: '1.5rem 1rem',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 12px rgba(10, 16, 68, 0.08)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '0.5rem',
  },
  firstLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '0.5rem',
    width: '100%',
  },
  actionsContainer: {
    display: 'flex',
    gap: '0.5rem',
    height: '49px',
    justifyContent: 'flex-end',
  },
  clearButton: {
    box: {
      alignSelf: 'center',
    },
    button: {
      color: 'primary.main',
      fontSize: '0.75rem',
      padding: '1rem 0.5rem',
    },
  },
  searchButton: {
    box: {
      alignSelf: 'center',
    },
    button: {
      minWidth: '46px',
      '& > .MuiButton-startIcon': {
        margin: '0',
      },
    },
  },
  chip: { minWidth: '100px' },
};

export default styles;
